import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FinDeNavListFilesRequest } from '../../Models/Invoice';
import { FinDeNavListZipRequest } from '../../Models/Invoice';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileGridService{

  private apiUrl = environment.apiUrl;
    //private apiUrl = 'https://localhost:7276/api'; //

    constructor(private http:HttpClient){

    }


getDownloadUrl(fileName: string,bucketName: string) {
   // const params = new HttpParams().set('fileName', fileName);
    const params = new HttpParams()
    .set('fileName', fileName)
    .set('bucketName', bucketName);

    console.log('Downloading file1:',fileName);
    return this.http.get<{ url: string }>(`${this.apiUrl}/download-url`, { params });

    //this.http.post(`${this.apiUrl}/FinDeNav/save-client`, payload);
  }

  /** Presigned url for the stored incoming excel; the API looks up the bucket and key by record id. */
  getImportDownloadUrl(id: string): Observable<{ url: string }> {
    const params = new HttpParams().set('id', id);
    return this.http.get<{ url: string }>(`${this.apiUrl}/import-download-url`, { params });
  }

  downloadFile(presignedUrl: string): Observable<Blob> {
    return this.http.get(presignedUrl, {
      responseType: 'blob'
    });
  }

// getDownloadUrl(filePath: string) {
//   const params = new HttpParams().set('fileName', filePath); // full path is fine here
//   console.log('Requesting download URL for:', filePath);

//   return this.http.get<{ url: string }>(`${this.apiUrl}/FinDeNav/download-url`, { params });
// }

// downloadFile(fileUrl: string) {
//   return this.http.get(fileUrl, { responseType: 'blob' });
// }

  // getNavListFiles(): Observable<FinDeNavListFilesRequest> {
  //   return this.http.get<FinDeNavListFilesRequest>(`${this.apiUrl}/FinDeNav/get-files`);
  // }

  getNavListFiles(): Observable<FinDeNavListFilesRequest[]> {
    return this.http.get<FinDeNavListFilesRequest[]>(`${this.apiUrl}/get-files`);
  }

  // getZipFilesList(): Observable<FinDeNavListZipRequest[]> {
  //   return this.http.get<FinDeNavListZipRequest[]>(`${this.apiUrl}/FinDeNav/get-files-in-zip`);
  // }


  getZipFilesList(id: string): Observable<FinDeNavListZipRequest[]> {
    console.log('getZipFilesList');
    //const url = `${this.apiUrl}/FinDeNav/get-files-in-zip?id=${encodeURIComponent(id)}`;
   // return this.http.get<FinDeNavListZipRequest[]>(url);
   // return this.http.get<FinDeNavListZipRequest[]>(`${this.apiUrl}/FinDeNav/get-files-in-zip`);

    const url = `${this.apiUrl}/get-files-in-zip?id=${encodeURIComponent(id)}`;
     return this.http.get<FinDeNavListZipRequest[]>(url);
  }


  // getNavListFiles(): Observable<FinDeNavListFilesRequest[][]> {
  //   return this.http.get<FinDeNavListFilesRequest[][]>(`${this.apiUrl}/FinDeNav/get-files`);
  // }


}